import { useEffect, useCallback, useRef, useState } from "react";
import "./BusinessDashboard.css";
import { Select, Form, Spin, Button, Space, notification } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { ReadCookie } from "../../utils/readCookie";
import { getRegion } from "../../redux/actions/region.action";
import { getPaymentTerm } from "../../redux/actions/paymentterm.action";
import { getGender } from "../../redux/actions/gender.action";
import { getAllCompany } from "../../redux/actions/companyAccess";
import { getAllScmBrand } from "../../redux/actions/scmBrand.action";
import { getCustomerType } from "../../redux/actions/customerType.action";
import { loadCustomers } from "../../redux/actions/customerForm";
import { getBussinessDashboard, getBussinessDashboardByRegion } from "../../redux/actions/bussinessDashboard.action";
import logo from "../../assets/images/logo.png";
import btnPrint from "../../assets/images/button_print.gif";
import xlsx from "../../assets/images/ico_xls_sm.gif";
import { TabTitle } from "../../utils/GeneralFunction";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { useDownloadExcel } from "react-export-table-to-excel";
import { getAllActiveCustomerType } from "../../redux/actions/getAllActive";
import axios from "axios";
import { saveAs } from "file-saver";
import { BASEURL } from "../../constant/config";
import pdf from "../../assets/images/PDF_file_icon.svg.png";
import { COMPANY_ID } from "../../utils/CompanyId";
import ScheduleModal from "../../components/ScheduleModal/ScheduleModal";
import { getRights } from "../../redux/actions/userRights.action";
import moment from "moment";

const { Option } = Select;

const BusinessDashboardByRegion = ({ token }) => {
  TabTitle("Business Dashboard By Region");
  const userName = ReadCookie("name");
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const focusInput = useRef(null);
  const [loader, setLoader] = useState(false);
  const {
    gender,
    region,
    companyAll,
    scmBrand,
    customerTypeNew,
    customerForms,
    bussinessDashboardByRegion,
  } = useSelector((state) => state);
  const menuId = ReadCookie("menuId");
  const [customer, setCustomer] = useState("All");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [scheduleData, setScheduleData] = useState({});
  const [userRights, setUserRights] = useState(false);

  let result =
    bussinessDashboardByRegion &&
    bussinessDashboardByRegion?.payload?.data?.reduce(function (r, a) {
      r[a.region_name] = r[a.region_name] || [];
      r[a.region_name].push(a);
      return r;
    }, Object.create(null));

  const bussinessdashboard = result && Object.values(result);

  console.log({ bussinessdashboard });

  //   let netShippedArray = bussinessdashboard && bussinessdashboard.find(item => item.some(entry => entry.tran_type === "NET SHIPPED $"));

  // // Step 2: Move the object with yearr = "TY" to the first position
  // const tyEntryIndex = netShippedArray && netShippedArray.findIndex(entry => entry.yearr === "TY");

  // if (tyEntryIndex > -1) {
  //   // Remove the 'TY' object and place it at the start
  //   const [tyEntry] = netShippedArray && netShippedArray.splice(tyEntryIndex, 1);
  //   netShippedArray.unshift(tyEntry);
  // }

  // // Now the 'TY' entry is first in the 'NET SHIPPED $' array
  // console.log("netShippedArray",netShippedArray);

  function debounce(cb, delay = 1000) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        cb(...args);
      }, delay);
    };
  }

  const handlePrint = () => {
    window.print();
  };

  const tableRef = useRef(null);

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Business DashBoard By Region",
    sheet: "Sheet",
  });

  const handleChanges = (val) => {
    if (val === "" || val === "All") return;
    setCustomer(val);
    dispatch(
      loadCustomers(
        token,
        null,
        null,
        null,
        null,
        null,
        val,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null
      )
    ).then((res) => {
      if (res?.type === "GET_ALL_CUSTOMERS_SUCCESS") {
        setCustomer(res?.payload?.data);
      }
    });
  };

  const optimizedFn = useCallback(debounce(handleChanges), []);

  const onFinish = async (e) => {
    await form.validateFields().then((values) => {
      let lastIndex = null;
      let lastYear = null;
      if (values.current_year !== null) {
        lastIndex = values.current_year;
        lastYear = lastIndex - 1;
      }
      values.last_year = lastYear;
      dispatch(getBussinessDashboardByRegion(token, values));
      setLoader(true);
    });
  };

  useEffect(() => {
    dispatch(getRegion(token, menuId));
    dispatch(getGender(token, menuId));
    dispatch(getPaymentTerm(token, menuId));
    dispatch(getAllCompany(token));
    dispatch(getAllScmBrand(token));
    dispatch(getCustomerType(token));
    dispatch(getAllActiveCustomerType(token));
  }, [dispatch, menuId, token]);



  const order = ["PLAN", "TY", "LY", "% VS LY", "PLAN ACHVD", "MISS PLAN"];

  const notificationKey = `open${Date.now()}`;
  const load = <div className="d-flex"><span className="spin-color mx-2">
    <Spin size="small" />
  </span><p>Please wait for a few minutes</p></div>;

  const handleDownload = async () => {
    try {
      // form.setFields("gender_id",isGenerate)
      notification.open({
        message: "Preparing PDF Download...",
        description: load,
        key: notificationKey,
        duration: 0,
      });

      await form.validateFields().then(async (values) => {
         const data = {
        last_year: (values.current_year === null || values.current_year === "All") ? values.current_year : Number(values.current_year) - 1,
        current_year: values.current_year !== "All" ? values.current_year : null,
        gender_id: values.gender_id === undefined || values.gender_id === "All" ? null : values.gender_id,
        customer_type_id: values.Customer_type === undefined || values.Customer_type === "All" ? null : values.Customer_type,
      };
        const response = await axios.post(`${BASEURL}getAll/businessDashboardByRegionPdf`, { data }, {
          responseType: "blob", // Important!
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const blob = new Blob([response.data], {
          type: "application/pdf"
        });
        saveAs(blob, "Business-Dashboard-By-Region.pdf");

        notification.destroy({ key: notificationKey });
        notification.success({
          message: "Download Successful",
          description: "Your PDF report has been downloaded.",
          className: "toast-success",
        });
      });
    } catch (error) {
      console.error("Download failed", error);

      // Destroy loader and show error notification
      notification.destroy({ key: notificationKey });
      notification.error({
        message: "Download Failed",
        description: "Something went wrong while downloading the PDF report.",
        className: "toast-error",
      });
    }
  };

  useEffect(() => {
    if (!token || !menuId) return;

    dispatch(getRights(token, menuId)).then((res) => {
      if (res?.type === "GET_USER_RIGHTS_SUCCESS") {
        setUserRights(res?.payload?.can_add ?? false);
      } else {
        setUserRights(false);
      }
    });
  }, [dispatch, menuId, token]);

  const handleSchedule = () => {
    form.validateFields().then((values) => {
      const report_filters = {
        last_year: (values.current_year === null || values.current_year === "All") ? values.current_year : Number(values.current_year) - 1,
        current_year: values.current_year !== "All" ? values.current_year : null,
        gender_id: values.gender_id === undefined || values.gender_id === "All" ? null : values.gender_id,
        customer_type_id: values.Customer_type === undefined || values.Customer_type === "All" ? null : values.Customer_type,
      };

      const getNameFromList = (list, id, idKey, nameKey, defaultValue = "All") => {
        if (!id || id === "All") return defaultValue;

        const item = list?.find((it) => it[idKey] === id);
        return item ? item[nameKey] : defaultValue;
      };


      // Labels for UI
      const uiData = {
        "To Date": values.current_year,
        "Gender": getNameFromList(gender?.payload?.data, values.gender_id, "gender_id", "gender_name"),
        "Customer Type": getNameFromList(customerTypeNew?.payload?.data, values.Customer_type, "customer_type_id", "customer_type_name"),
      };
      const emailDates = {
        from: `01-01-${values.current_year}`,
        to: `12-31-${values.current_year}`
      };
      const report_columns = {
        bussinessdashboard
      };
      setScheduleData({
        uiData,
        report_filters,
        report_columns,
        report_id: 3,
        report_name: "Business Dashboard By Region",
        api_route: "/businessDashboardByRegionPdf",
        type: "pdf",
        emailDates
      });

      setIsModalOpen(true);
    }).catch(errorInfo => {
      console.log("Form validation failed:", errorInfo);
    });
  };




  return (
    <>
      <ScheduleModal
        token={token}
        open={isModalOpen}
        data={scheduleData || {}}
        onClose={() => setIsModalOpen(false)}
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col">
            <div className="header_class business_class full-width">
              {/* inputs Container */}

              <div className="row business_header justify-content-between pb-0 marginAuto">
                {/**** / Logo *****/}
                <div className="col-3 d-flex align-items-start box-space">
                  <div className="logobrand">
                    <img id="ImgLogo" alt="logo" src={logo} />
                  </div>
                </div>
                {/* <div className="logo_Container">
            <img src="http:
          </div> */}
                {/* Items */}
                {/* <div className="col-sm-6 box-space pl-sm-0">
                <div className="brand-para">
                  <div>DL1961 Premium Denim Inc.</div>
                  <div>121 Varick Street</div>
                  <div>4th Floor</div>
                  <div>New York, NY 10013</div>
                  <div>(P) 646-514-9736</div>
                  <div>(F) 212-991-9989</div>
                  <div>(E) sales@DL1961.com</div>
                </div>
              </div> */}
                <div className="col-3 box-space right-content-header text-right">
                  <div className=" d-flex justify-content-end">
                    <div className=" d-flex justify-content-end printing_class">
                      <div className="print_icon printing_class">
                        <i
                          id="Image1"
                          title="Print"
                          alt="Print"
                          className="fa-solid fa-print printing_class"
                        // onClick={handlePrint}
                        ></i>
                      </div>
                      <div className="print_icon printing_class">
                        <input
                          type="image"
                          name="ImgPdf"
                          alt="Export to PDF"
                          id="ImgPdf"
                          title="Export to PDF"
                          src={pdf}
                          onClick={handleDownload}
                          style={{
                            borderWidth: "0px",
                            height: "14px",
                            cursor: "pointer",
                          }}
                        />
                      </div>
                      <div className="print_icon printing_class">
                        {bussinessDashboardByRegion ? (
                          <input
                            type="image"
                            name="ImgExcel"
                            alt="Export to excel"
                            id="ImgExcel"
                            title="Export to excel"
                            src={xlsx}
                            onClick={onDownload}
                            style={{
                              borderWidth: "0px",
                              height: "14px",
                              cursor: "pointer",
                            }}
                          />
                        ) : (
                          <input
                            type="image"
                            name="ImgExcel"
                            alt="Export to excel"
                            id="ImgExcel"
                            title="Export to excel"
                            src={xlsx}
                            style={{ borderWidth: "0px", height: "14px" }}
                          />
                        )}
                      </div>
                    </div>
                    <span style={{ fontWeight: "bolder" }}>
                      Business Dashboard By Region
                      <br />
                      Login as:
                      <span id="lblSalesPerson" style={{ fontWeight: "bold" }}>
                        {" "}
                        {userName}
                      </span>
                    </span>
                  </div>
                </div>
              </div>

              {/* Filters Table */}
              <div className="col business_header marginAuto">
                <Form form={form} name="control-hooks" onFinish={onFinish}>
                  <div className="main_form row">
                    <div className="col-6">
                      <div className=" d-flex flex-row align-items-baseline">
                        <label className="labels width30">Year:</label>
                        <div className=" w-100">
                          <Form.Item name="current_year" initialValue={"2026"}>
                            <Select
                              style={{ width: "70px" }}
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                              showSearch
                              defaultValue={form.getFieldValue().Year}
                              size="small"
                              filterSort={(optionA, optionB) =>
                                optionB?.value !== null
                                  ? optionA.children
                                    .toLowerCase()
                                    .localeCompare(
                                      optionB.children.toLowerCase()
                                    )
                                  : ""
                              }
                            >
                              <Option defaultValue={null}>All</Option>
                              <Option value="2020">2020</Option>
                              <Option value="2021">2021</Option>
                              <Option value="2022">2022</Option>
                              <Option value="2023">2023</Option>
                              <Option value="2024">2024</Option>
                              <Option value="2025">2025</Option>
                              <Option value="2026">2026</Option>
                              <Option value="2027">2027</Option>
                            </Select>
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className=" d-flex flex-row align-items-baseline">
                        <label className="labels width30">Gender:</label>
                        <div className=" w-100">
                          <Form.Item name="gender_id" initialValue={"All"}>
                            <Select
                              style={{ width: "70px" }}
                              showSearch
                              size="small"
                            >
                              <Option value="All">All</Option>
                              {gender &&
                                gender?.payload?.data.map((it, index) => {
                                  return (
                                    <Option key={index} value={it.gender_id}>
                                      {it.gender_name}
                                    </Option>
                                  );
                                })}
                            </Select>
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className=" d-flex flex-row align-items-baseline">
                        <label className="labels width30">Customer Type:</label>
                        <div className=" w-100">
                          <Form.Item name="Customer_type" initialValue={"All"}>
                            <Select
                              style={{ width: "70px" }}
                              showSearch
                              size="small"
                            >
                              <Option value="All">All</Option>
                              {customerTypeNew?.payload?.data.map((item) => {
                                return (
                                  <Option
                                    key={item.customer_type_id}
                                    value={item.customer_type_id}
                                  >
                                    {item.customer_type_name}
                                  </Option>
                                );
                              })}
                            </Select>
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                    <div className="col-2">
                      <div className=" d-flex flex-row align-items-baseline"
                        style={{
                          justifyContent: "start",
                          marginTop: "3px",
                        }}
                      >
                        <label className=" no_visibility">none</label>
                        <Button
                          type="primary"
                          htmlType="submit"
                          className="submit-btn-btm m-0"
                        >
                          Generate
                        </Button>
                      </div>
                    </div>
                    <div className="col-1">
                      <div
                        className=" d-flex flex-row align-items-baseline"
                        style={{
                          justifyContent: "start",
                          marginTop: "3px",
                        }}
                      >
                        {userRights && (
                          <Button type="primary" onClick={handleSchedule}>
                            Schedule
                          </Button>
                        )}
                      </div>
                    </div>
                  </div>
                </Form>
              </div>

              {/* Render Data Table */}
              <div
                className="table_content full-table-width scrollbar-style business-dashboard-table-fit"
                ref={tableRef}
              >
                <div className="max-1400-width">
                  {bussinessdashboard
                    ? bussinessdashboard.map((bussiness, index) => {
                      return (
                        <div className="data_Table fit-content-width">
                          <div key={index}>
                            <table className="table full-width business-table-main width-initial">
                              <tbody className="stripedTable">
                                <tr style={{ height: "20px", borderTop: "1px solid black", }}>
                                  <td
                                    style={{ paddingLeft: "0px", borderRight: "1px solid black" }}
                                    colSpan={17}
                                  >
                                    <div
                                      className="table_Heading-new"
                                      style={{ width: "1120px" }}
                                    >
                                      {bussiness[0].region_name}
                                    </div>
                                  </td>
                                </tr>
                                <tr style={{ height: "20px", borderTop: "1px solid black" }}>
                                  <td
                                    className="serial_No fontBold"
                                    style={{ width: "26px", minWidth: "26px" }}
                                  >
                                    #
                                  </td>
                                  <td
                                    style={{ width: "70px", minWidth: "70px" }}
                                  ></td>
                                  <td
                                    className="fontBold"
                                    style={{
                                      width: "65px",
                                      minWidth: "65px",
                                      textAlign: "right",
                                      paddingRight: "3px",
                                    }}
                                  >
                                    JAN
                                  </td>
                                  <td
                                    className="fontBold"
                                    style={{
                                      width: "65px",
                                      minWidth: "65px",
                                      textAlign: "right",
                                      paddingRight: "3px",
                                    }}
                                  >
                                    FEB
                                  </td>
                                  <td
                                    className="fontBold"
                                    style={{
                                      width: "65px",
                                      minWidth: "65px",
                                      textAlign: "right",
                                      paddingRight: "3px",
                                    }}
                                  >
                                    MAR
                                  </td>
                                  <td
                                    className="fontBold"
                                    style={{
                                      width: "65px",
                                      minWidth: "65px",
                                      textAlign: "right",
                                      paddingRight: "3px",
                                    }}
                                  >
                                    APR
                                  </td>
                                  <td
                                    className="fontBold"
                                    style={{
                                      width: "65px",
                                      minWidth: "65px",
                                      textAlign: "right",
                                      paddingRight: "3px",
                                    }}
                                  >
                                    MAY
                                  </td>
                                  <td
                                    className="fontBold"
                                    style={{
                                      width: "65px",
                                      minWidth: "65px",
                                      textAlign: "right",
                                      paddingRight: "3px",
                                    }}
                                  >
                                    JUN
                                  </td>
                                  <td
                                    style={{
                                      width: "80px",
                                      minWidth: "65px",
                                      textAlign: "right",
                                      paddingRight: "3px",
                                    }}
                                    className="spring fontBold"
                                  >
                                    SPRING
                                  </td>
                                  <td
                                    className="fontBold"
                                    style={{
                                      width: "65px",
                                      minWidth: "65px",
                                      textAlign: "right",
                                      paddingRight: "3px",
                                    }}
                                  >
                                    JUL
                                  </td>
                                  <td
                                    className="fontBold"
                                    style={{
                                      width: "65px",
                                      minWidth: "65px",
                                      textAlign: "right",
                                      paddingRight: "3px",
                                    }}
                                  >
                                    AUG
                                  </td>
                                  <td
                                    className="fontBold"
                                    style={{
                                      width: "65px",
                                      minWidth: "65px",
                                      textAlign: "right",
                                      paddingRight: "3px",
                                    }}
                                  >
                                    SEP
                                  </td>
                                  <td
                                    className="fontBold"
                                    style={{
                                      width: "65px",
                                      minWidth: "65px",
                                      textAlign: "right",
                                      paddingRight: "3px",
                                    }}
                                  >
                                    OCT
                                  </td>
                                  <td
                                    className="fontBold"
                                    style={{
                                      width: "65px",
                                      minWidth: "65px",
                                      textAlign: "right",
                                      paddingRight: "3px",
                                    }}
                                  >
                                    NOV
                                  </td>
                                  <td
                                    className="fontBold"
                                    style={{
                                      width: "65px",
                                      minWidth: "65px",
                                      textAlign: "right",
                                      paddingRight: "3px",
                                    }}
                                  >
                                    DEC
                                  </td>
                                  <td
                                    style={{
                                      width: "80px",
                                      minWidth: "80px",
                                      textAlign: "right",
                                      paddingRight: "3px",
                                    }}
                                    className="fall fontBold"
                                  >
                                    FALL
                                  </td>
                                  <td
                                    style={{
                                      width: "80px",
                                      minWidth: "80px",
                                      textAlign: "right",
                                      paddingRight: "3px",
                                      borderRight: "1px solid black"
                                    }}
                                    className="total fontBold"
                                  >
                                    TOTAL
                                  </td>
                                </tr>
                                {/* Table data */}
                                {bussiness
                                  ?.slice()
                                  ?.sort((a, b) => order.indexOf(a.yearr) - order.indexOf(b.yearr))
                                  ?.map((data, index) => {

                                    return (
                                      <tr key={index}>
                                        <td className="serial_No color_black">
                                          {index + 1}
                                        </td>

                                        <td className="color_black">
                                          {data && data.yearr}
                                        </td>

                                        {/* Jan */}
                                        <td className={`${data.jan < 0 ? "color_red"
                                          : (data.yearr === "% VS LY" || data.yearr === "PLAN ACHVD") && data.jan > 0 ? "color_green"
                                            : ""}`} style={{ textAlign: "right", paddingRight: "3px" }}>
                                          {data.yearr !== "% VS LY" && data.yearr !== "PLAN ACHVD" ? "$" : ""}
                                          {data?.jan != null ? data.jan.toLocaleString("en-US") : ""}
                                          {data.yearr == "% VS LY" || data.yearr == "PLAN ACHVD" ? "%" : ""}
                                        </td>

                                        {/* Feb */}
                                        <td className={`${data.feb < 0 ? "color_red" : (data.yearr === "% VS LY" || data.yearr === "PLAN ACHVD") && data.feb > 0 ? "color_green"
                                          : ""}`} style={{ textAlign: "right", paddingRight: "3px" }}>
                                          {data.yearr !== "% VS LY" && data.yearr !== "PLAN ACHVD" ? "$" : ""}
                                          {data?.feb != null ? data.feb.toLocaleString("en-US") : ""}
                                          {data.yearr == "% VS LY" || data.yearr == "PLAN ACHVD" ? "%" : ""}
                                        </td>

                                        {/* Mar */}
                                        <td className={`${data.mar < 0 ? "color_red" : (data.yearr === "% VS LY" || data.yearr === "PLAN ACHVD") && data.mar > 0 ? "color_green"
                                          : ""}`} style={{ textAlign: "right", paddingRight: "3px" }}>
                                          {data.yearr !== "% VS LY" && data.yearr !== "PLAN ACHVD" ? "$" : ""}
                                          {data?.mar != null ? data.mar.toLocaleString("en-US") : ""}
                                          {data.yearr == "% VS LY" || data.yearr == "PLAN ACHVD" ? "%" : ""}
                                        </td>

                                        {/* Apr */}
                                        <td className={`${data.apr < 0 ? "color_red" : (data.yearr === "% VS LY" || data.yearr === "PLAN ACHVD") && data.apr > 0 ? "color_green"
                                          : ""}`} style={{ textAlign: "right", paddingRight: "3px" }}>
                                          {data.yearr !== "% VS LY" && data.yearr !== "PLAN ACHVD" ? "$" : ""}
                                          {data?.apr != null ? data.apr.toLocaleString("en-US") : ""}
                                          {data.yearr == "% VS LY" || data.yearr == "PLAN ACHVD" ? "%" : ""}
                                        </td>

                                        {/* May */}
                                        <td className={`${data.may < 0 ? "color_red" : (data.yearr === "% VS LY" || data.yearr === "PLAN ACHVD") && data.may > 0 ? "color_green"
                                          : ""}`} style={{ textAlign: "right", paddingRight: "3px" }}>
                                          {data.yearr !== "% VS LY" && data.yearr !== "PLAN ACHVD" ? "$" : ""}
                                          {data?.may != null ? data.may.toLocaleString("en-US") : ""}
                                          {data.yearr == "% VS LY" || data.yearr == "PLAN ACHVD" ? "%" : ""}
                                        </td>

                                        {/* Jun */}
                                        <td className={`${data.jun < 0 ? "color_red" : (data.yearr === "% VS LY" || data.yearr === "PLAN ACHVD") && data.jun > 0 ? "color_green"
                                          : ""}`} style={{ textAlign: "right", paddingRight: "3px" }}>
                                          {data.yearr !== "% VS LY" && data.yearr !== "PLAN ACHVD" ? "$" : ""}
                                          {data?.jun != null ? data.jun.toLocaleString("en-US") : ""}
                                          {data.yearr == "% VS LY" || data.yearr == "PLAN ACHVD" ? "%" : ""}
                                        </td>

                                        {/* Spring */}
                                        <td className={`${data.spring < 0 ? "color_red" : (data.yearr === "% VS LY" || data.yearr === "PLAN ACHVD") && data.spring > 0 ? "color_green"
                                          : ""}`} style={{ textAlign: "right", paddingRight: "3px" }}>
                                          {data.yearr !== "% VS LY" && data.yearr !== "PLAN ACHVD" ? "$" : ""}
                                          {data?.spring != null ? data.spring.toLocaleString("en-US") : ""}
                                          {data.yearr == "% VS LY" || data.yearr == "PLAN ACHVD" ? "%" : ""}
                                        </td>

                                        {/* Jul */}
                                        <td className={`${data.jul < 0 ? "color_red" : (data.yearr === "% VS LY" || data.yearr === "PLAN ACHVD") && data.jul > 0 ? "color_green"
                                          : ""}`} style={{ textAlign: "right", paddingRight: "3px" }}>
                                          {data.yearr !== "% VS LY" && data.yearr !== "PLAN ACHVD" ? "$" : ""}
                                          {data?.jul != null ? data.jul.toLocaleString("en-US") : ""}
                                          {data.yearr == "% VS LY" || data.yearr == "PLAN ACHVD" ? "%" : ""}
                                        </td>

                                        {/* Aug */}
                                        <td className={`${data.aug < 0 ? "color_red" : (data.yearr === "% VS LY" || data.yearr === "PLAN ACHVD") && data.aug > 0 ? "color_green"
                                          : ""}`} style={{ textAlign: "right", paddingRight: "3px" }}>
                                          {data.yearr !== "% VS LY" && data.yearr !== "PLAN ACHVD" ? "$" : ""}
                                          {data?.aug != null ? data.aug.toLocaleString("en-US") : ""}
                                          {data.yearr == "% VS LY" || data.yearr == "PLAN ACHVD" ? "%" : ""}
                                        </td>

                                        {/* Sep */}
                                        <td className={`${data.sep < 0 ? "color_red" : (data.yearr === "% VS LY" || data.yearr === "PLAN ACHVD") && data.sep > 0 ? "color_green"
                                          : ""}`} style={{ textAlign: "right", paddingRight: "3px" }}>
                                          {data.yearr !== "% VS LY" && data.yearr !== "PLAN ACHVD" ? "$" : ""}
                                          {data?.sep != null ? data.sep.toLocaleString("en-US") : ""}
                                          {data.yearr == "% VS LY" || data.yearr == "PLAN ACHVD" ? "%" : ""}
                                        </td>

                                        {/* Oct */}
                                        <td className={`${data.oct < 0 ? "color_red" : (data.yearr === "% VS LY" || data.yearr === "PLAN ACHVD") && data.oct > 0 ? "color_green"
                                          : ""}`} style={{ textAlign: "right", paddingRight: "3px" }}>
                                          {data.yearr !== "% VS LY" && data.yearr !== "PLAN ACHVD" ? "$" : ""}
                                          {data?.oct != null ? data.oct.toLocaleString("en-US") : ""}
                                          {data.yearr == "% VS LY" || data.yearr == "PLAN ACHVD" ? "%" : ""}
                                        </td>

                                        {/* Nov */}
                                        <td className={`${data.nov < 0 ? "color_red" : (data.yearr === "% VS LY" || data.yearr === "PLAN ACHVD") && data.nov > 0 ? "color_green"
                                          : ""}`} style={{ textAlign: "right", paddingRight: "3px" }}>
                                          {data.yearr !== "% VS LY" && data.yearr !== "PLAN ACHVD" ? "$" : ""}
                                          {data?.nov != null ? data.nov.toLocaleString("en-US") : ""}
                                          {data.yearr == "% VS LY" || data.yearr == "PLAN ACHVD" ? "%" : ""}
                                        </td>

                                        {/* Dec */}
                                        <td className={`${data.decc < 0 ? "color_red" : (data.yearr === "% VS LY" || data.yearr === "PLAN ACHVD") && data.decc > 0 ? "color_green"
                                          : ""}`} style={{ textAlign: "right", paddingRight: "3px" }}>
                                          {data.yearr !== "% VS LY" && data.yearr !== "PLAN ACHVD" ? "$" : ""}
                                          {data?.decc != null ? data.decc.toLocaleString("en-US") : ""}
                                          {data.yearr == "% VS LY" || data.yearr == "PLAN ACHVD" ? "%" : ""}
                                        </td>

                                        {/* Fall */}
                                        <td className={`${data.fall < 0 ? "color_red" : (data.yearr === "% VS LY" || data.yearr === "PLAN ACHVD") && data.fall > 0 ? "color_green"
                                          : ""}`} style={{ textAlign: "right", paddingRight: "3px" }}>
                                          {data.yearr !== "% VS LY" && data.yearr !== "PLAN ACHVD" ? "$" : ""}
                                          {data?.fall != null ? data.fall.toLocaleString("en-US") : ""}
                                          {data.yearr == "% VS LY" || data.yearr == "PLAN ACHVD" ? "%" : ""}
                                        </td>

                                        {/* Total */}
                                        <td className={`${data.total < 0 ? "color_red" : (data.yearr === "% VS LY" || data.yearr === "PLAN ACHVD") && data.total > 0 ? "color_green"
                                          : ""}`} style={{ textAlign: "right", paddingRight: "3px", borderRight: "1px solid black" }}>
                                          {data.yearr !== "% VS LY" && data.yearr !== "PLAN ACHVD" ? "$" : ""}
                                          {data?.total != null ? data.total.toLocaleString("en-US") : ""}
                                          {data.yearr == "% VS LY" || data.yearr == "PLAN ACHVD" ? "%" : ""}
                                        </td>

                                      </tr>
                                    );
                                  })}
                                <tr style={{ borderTop: "1px solid black" }}>
                                  <td colSpan={17} style={{ height: "20px" }}></td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      );
                    })
                    : loader && (
                      <div className="loader">
                        <Space size="middle">
                          <Spin />
                        </Space>
                      </div>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BusinessDashboardByRegion;
